import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { keys } from 'lodash';

import InlineButton from '../../InlineButton';
import headerContentAlignment from '../../../config/sectionHeader/headerContentAlignment';

import styles, { placeholderHeight } from './HeaderLogoPlaceholder.scss';

const HeaderLogoPlaceholder = ({ align, onUploadImage, containerHeight }) => (
  <div
    className={cx(styles.container, styles[`${align}Align`])}
    style={{ maxHeight: `${containerHeight}px` }}
  >
    <div
      className={styles.placeholder}
      data-e2e="header-logo-placeholder"
      onClick={onUploadImage}
    >
      <InlineButton
        className={styles.ico}
        iconClassName="icon-custom-image-placeholder"
      />
      <div className={styles.button}>Browse</div>
    </div>
  </div>
);

HeaderLogoPlaceholder.propTypes = {
  align: PropTypes.oneOf(keys(headerContentAlignment)),
  onUploadImage: PropTypes.func.isRequired,
  containerHeight: PropTypes.number,
};

HeaderLogoPlaceholder.defaultProps = {
  align: headerContentAlignment.left,
  containerHeight: placeholderHeight,
};

export default HeaderLogoPlaceholder;
